import { render, staticRenderFns } from "./TaskDetailDrawer.vue?vue&type=template&id=349920b5"
import script from "./TaskDetailDrawer.vue?vue&type=script&lang=js"
export * from "./TaskDetailDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports